import BaseService from "./Base.Service";

class ProjectsService extends BaseService {
	constructor() {
		const model = {
			name: { type: String, required: true },
			users: { type: Array, required: true },
			start_date: { type: String, required: true },
			end_date: { type: String, required: false },
			erp_code: { type: String, required: false }
		};

		super("projects", model);
	}

    async getHours() {
        try {
            const { data } = await this.conn.axios.get(`/projects/get-list-dash-emp`);
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao recuperar dados", false, err);
        }
    }
}

export default ProjectsService;
